import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import {
  ChecklistTemplateVersionMessages,
  MessageDesignBUtils
} from '../../content/components/message-design-b/message-design-b.utils';
import { RequestClientService } from '../../services/client/request-client.service';
import {
  ChecklistTemplateVersionAction
} from '../../states/checklist-template-version/checklist-template-version.action';
import { MessageModel } from '../../content/components/message-design-b/message.model';

export class SseClassEvent extends SseEventBase {

  type: SseEventType = 'class';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.CLASS_CREATED: {
          this.on.classCreated$.next(resp.targetId);
          this.inProgressMessageService.removeMessage(resp.demandId);
          break;
        }
        case NotificationReasonEnum.CLASS_EDITED: {
          this.on.classUpdated$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.CLASS_DELETED: {
          this.on.classDeleted$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.CLASS_CREATE_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createClassCreateFailed());
          break;
        }
        case NotificationReasonEnum.CLASS_EDITED_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createClassEditedFailed());
          break;
        }
        case NotificationReasonEnum.CLASS_DELETED_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createClassDeleteFailed());
          break;
        }

        case NotificationReasonEnum.PARENT_SUBCLASS_UPDATE: {
          this.on.parentCanContainComponents$.next(true);
          this.on.parentSubclassUpdated$.next(resp.targetId);
          break;
        }
        case NotificationReasonEnum.PARENT_SUBCLASS_UPDATE_FAILED: {
          this.messageClientService.messages$.next(MessageDesignBUtils.createParentSubclassFailed());
          break;
        }
      }
    });
  }
}
